import { graphql } from "gatsby"
import React, { useEffect } from "react"
import Seo from "../components/Seo/Seo"
import Layout from "../components/layout"
import ModuleMicrosites from "../modules/microsites"

const Restaurant = (props, siteName) => {
  const post = props.data.post
  const { location } = props
  const microSiteName = post.siteName.selectMicrosite

  useEffect(() => {
    const smoothScrollLinks = document.querySelectorAll('a[href^="#"]')
    // Select all anchor links with a href value that starts with #

    smoothScrollLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault() // Prevent the default link behavior

        const target = document.querySelector(this.getAttribute("href"))
        // Get the target element based on the href attribute of the link

        if (target) {
          // If the target element exists, scroll to it smoothly
          const body = document.body
          const html = document.documentElement
          const offset = target.offsetTop

          body.style.scrollBehavior = "smooth"
          html.style.scrollBehavior = "smooth"
          window.scrollTo({
            top: offset,
            behavior: "smooth",
          })

          // Reset the scroll behavior to the default after scrolling is complete
          setTimeout(function () {
            body.style.scrollBehavior = "initial"
            html.style.scrollBehavior = "initial"
          }, 1000) // Change the value to match the duration of your smooth scroll animation
        }
      })
    })
  }, [])

  return (
    <div
      className={`fullPageanimation global-site micro-site ${microSiteName}-site `}
    >
      <Layout props={props} location={location}>
        <ModuleMicrosites
          modules={post.restaurantContent}
          location={location}
          siteName={post.siteName.selectMicrosite}
        />
      </Layout>
    </div>
  )
}
export default Restaurant
export const restaurantsQuery = graphql/* GraphQL */ `
  query eatDrinkById($id: String!) {
    post: wpEatDrink(id: { eq: $id }) {
      id
      title
      siteName: restaurantContent {
        selectMicrosite
      }
      seo {
        metaDesc
        canonical
        opengraphDescription
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphTitle
        opengraphType
        opengraphUrl
        opengraphSiteName
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          publicUrl
        }
        twitterImage {
          publicUrl
        }
      }
      ...EatDrinkFragment
    }
  }
`
export const Head = ({ data }) => {
  const post = data.post
  return <Seo seo={post.seo} />
}